<div class="h-auto w-auto p-4 d-flex flex-column justify-content-center align-items-center">
  <i class="{{icon}} fa-3x mb-3 text-warning" *ngIf="icon"></i>
  <span class="text-center mb-3">{{message}}</span>
  <button *ngIf="showButton" class="btn btn-primary px-4" (click)="onClose()">
    {{buttonText}}
  </button>
</div>
